module.exports = __webpack_public_path__ + "img/change-icon.cc2c4e2c.png";